import { pdfjs } from 'react-pdf'

// See https://github.com/wojtekmaj/react-pdf#configure-pdfjs-worker
export const initReactPdf = () => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`
}

